<template>
    <v-app>
        <v-app-bar v-if="isAuthenticated || showPublicAppBar" app flat clipped-right color="grey lighten-4">
            <v-toolbar-title
                v-if="!isAuthenticated"
                class="headline text-uppercase"
            >
                <span class="font-weight-light">Profit</span>
                <span>Job</span>
            </v-toolbar-title>
            <v-app-bar-nav-icon v-if="isAuthenticated" @click="sidebar = !sidebar"/>
            <v-spacer/>
            <v-btn
                v-show="isAuthenticated"
                text
                @click="signOut()"
            >
                Выйти
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer
            v-if="isAuthenticated"
            v-model="sidebar"
            app
            v-bind:width="300"
        >
            <v-card flat>
                <v-toolbar flat color="grey lighten-4">
                    <v-toolbar-title class="headline text-uppercase">
                        <span class="font-weight-light">Profit</span>
                        <span>Job</span>
                    </v-toolbar-title>
                </v-toolbar>
            </v-card>
            <v-divider/>
            <v-card flat>
                <v-list flat class="pt-0 pb-0">
                    <router-link
                        to="/task"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>mdi-briefcase</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div class="pt-1 d-inline-block">
                                        Актуальные задачи
                                    </div>
                                    <v-chip
                                        v-if="user.task > 0"
                                        small
                                        label
                                        class="mt-1 px-2 py-0 float-right"
                                    >
                                        {{ user.task }}
                                    </v-chip>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link
                        to="/task/schedule"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>mdi-briefcase-clock</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div class="pt-1 d-inline-block">
                                        Отложенные задачи
                                    </div>
                                    <v-chip
                                        v-if="user.taskSchedule > 0"
                                        small
                                        label
                                        class="mt-1 px-2 py-0 float-right"
                                    >
                                        {{ user.taskSchedule }}
                                    </v-chip>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link
                        v-for="(item, i) in sidebarItems"
                        :key="i"
                        :to="item.href"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-list>
                <v-divider></v-divider>
                <v-card flat>
                    <v-card-text class="subtitle-1">
                        Телемаркетинг
                    </v-card-text>
                </v-card>
                <v-divider></v-divider>
                <v-list flat class="pt-0 pb-0">
                    <router-link
                        to="/marketing/task"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>mdi-briefcase</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div class="pt-1 d-inline-block">
                                        Актуальные задачи
                                    </div>
                                    <v-chip
                                        v-if="user.marketingTask > 0"
                                        small
                                        label
                                        class="mt-1 px-2 py-0 float-right"
                                    >
                                        {{ user.marketingTask }}
                                    </v-chip>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link
                        to="/marketing/task/schedule"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>mdi-briefcase-clock</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <div class="pt-1 d-inline-block">
                                        Отложенные задачи
                                    </div>
                                    <v-chip
                                        v-if="user.marketingTaskSchedule > 0"
                                        small
                                        label
                                        class="mt-1 px-2 py-0 float-right"
                                    >
                                        {{ user.marketingTaskSchedule }}
                                    </v-chip>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <router-link
                        to="/marketing/company"
                        active-class="grey lighten-4"
                        class="d-block"
                        exact flat
                    >
                        <v-list-item>
                            <v-list-item-action class="mr-3">
                                <v-icon>mdi-domain</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Компании</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </v-list>
                <v-divider></v-divider>
            </v-card>
        </v-navigation-drawer>
        <v-main>
            <v-divider v-if="isAuthenticated || showPublicAppBar"/>
            <router-view/>
        </v-main>
    </v-app>
</template>

<script>
import { newsEnabled } from './config/features'
import { publicPages } from './config/variant'

export default {
    name: 'App',
    data () {
        return {
            sidebar: true,
            sidebarItems: [
                {
                    href: '/company',
                    title: 'Компании',
                    icon: 'mdi-domain',
                },
                {
                    href: '/schedule',
                    title: 'Расписание',
                    icon: 'mdi-calendar-lock',
                },
                {
                    href: '/virtual',
                    title: 'Виртуалы',
                    icon: 'mdi-account-network',
                },
                {
                    href: '/admin',
                    title: 'Администраторы',
                    icon: 'mdi-account-tie',
                },
                {
                    href: '/stats',
                    title: 'Статистика',
                    icon: 'mdi-chart-bar',
                },
                ...(newsEnabled ? [{
                    href: '/news',
                    title: 'Новости',
                    icon: 'mdi-newspaper-variant-outline',
                }] : []),
            ],
        }
    },
    computed: {
        showPublicAppBar () {
            return publicPages.showAppBar
        },
        isAuthenticated () {
            return this.$store.getters.isAuthenticated
        },
        user () {
            return this.$store.getters.user
        },
    },
    methods: {
        signOut () {
            this.$axios.post('/manager/sign-out')
                .then(res => {
                    if (res.data.success) {
                        this.$store.commit('removeToken')
                        this.$store.commit('removeUser')
                        delete this.$axios.defaults.headers.common['Authorization']
                        this.$router.push('/sign-in')
                    }
                })
        },
    },
}
</script>

<style scoped lang="scss">
.v-btn--active {
    opacity: 1 !important;
}

.v-navigation-drawer a {
    text-decoration: none;
    color: inherit;
}

.v-navigation-drawer a:hover {
    background-color: #f5f5f5;
}

.menuable__content__active {
    .v-list-item {
        background-color: #ffffff;
    }
}
</style>
